<template>
  <div class="base-wb-loading flex-center" :style="cssStyle">
    <img class="loading-icon" src="@/assets/loading_small.webp" />
    <div class="loading-text" v-if="desc">{{ desc }}</div>
  </div>
</template>

<script>
  export default {
    name: 'base-wb-empty',

    props: {
      desc: {
        type: String,
        default: ''
      },
      cssStyle: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
.base-wb-loading {
  width: 100%;
  padding: 20px 14px 40px;

  .loading-icon {
    width: 16px;
    height: 16px;
  }

  .loading-text {
    font-size: 13px;
    color: #666666;
    font-weight: 400;
    padding-left: 8px;
  }
}
</style>
